/**
 * SectionFilter — reusable Company + Period filter bar, visually identical
 * to the dashboard's top-level filter (same "dashboard-filters" styling).
 * Each dashboard section (Transactions, Journal Entries, Ledger, Trial
 * Balance) owns its own instance + state, so filtering one section never
 * affects another.
 */

import React from 'react';
import { dateFilterOptions } from '../utils/dateFilters';

const SectionFilter = ({
  idPrefix,
  companies = [],
  companyId,
  onCompanyChange,
  dateFilter,
  onDateFilterChange,
  customFrom,
  customTo,
  onCustomFromChange,
  onCustomToChange,
  onReset,
  showPeriod = true,
}) => {
  return (
    <div className="dashboard-filters section-filters">
      <div className="filter-group">
        <label htmlFor={`${idPrefix}-company`}>Company</label>
        <select
          id={`${idPrefix}-company`}
          value={companyId}
          onChange={(e) => onCompanyChange(e.target.value)}
        >
          <option value="all">All Companies</option>
          {companies?.map((c) => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>

      {showPeriod && (
        <>
          <div className="filter-group">
            <label htmlFor={`${idPrefix}-period`}>Period</label>
            <select
              id={`${idPrefix}-period`}
              value={dateFilter}
              onChange={(e) => onDateFilterChange(e.target.value)}
            >
              {dateFilterOptions.map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </div>

          {dateFilter === 'custom' && (
            <>
              <div className="filter-group">
                <label htmlFor={`${idPrefix}-from`}>From</label>
                <input
                  id={`${idPrefix}-from`}
                  type="date"
                  value={customFrom}
                  onChange={(e) => onCustomFromChange(e.target.value)}
                />
              </div>
              <div className="filter-group">
                <label htmlFor={`${idPrefix}-to`}>To</label>
                <input
                  id={`${idPrefix}-to`}
                  type="date"
                  value={customTo}
                  onChange={(e) => onCustomToChange(e.target.value)}
                />
              </div>
            </>
          )}
        </>
      )}

      <div className="filter-group filter-actions">
        <button type="button" className="reset-button" onClick={onReset}>Reset</button>
      </div>
    </div>
  );
};

export default SectionFilter;
